import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IEvent } from 'src/app/pages/private/event/shared/models/event.model';

@Component({
    selector: 'app-event',
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.scss'],
})
export class EventComponent {
    @Input()
    public event: IEvent;

    @Input()
    public type: string;

    public get cancelled(): boolean {
        return this.event.cancelled;
    }
    public get published(): boolean {
        return this.event.published;
    }
    public get title(): string {
        return this.event.vc_tittle_event;
    }
    public get uuidEvent(): string {
        return this.event.vc_uuid;
    }
    public get imgEvent(): string {
        return this.event.vc_photo_event;
    }
    public get description(): string {
        return this.event.vc_description_event;
    }
    public get start_date(): string {
        return this.event.date[0]?.vc_start_date;
    }
    public get month(): string {
        const date = new Date(this.event.date[0]?.vc_start_date);
        return this.getMonthName(date.getMonth());
    }
    public get start_hour(): string {
        return this.event.date[0]?.vc_start_hour;
    }
    public get subscribers(): number {
        return this.event.subscribers;
    }

    @Output()
    public actionEvent: EventEmitter<{ action: string; event: IEvent }> = new EventEmitter<{ action: string; event: IEvent }>();
    constructor(public router: Router) {}

    handleImageError(event: Event) {
        const imgElement = event.target as HTMLImageElement;
        imgElement.src = 'assets/img/default-placeholder.jpg';
    }
    private getMonthName(month: number): string {
        const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        return months[month];
    }
    public handleAction(action: string) {
        this.actionEvent.emit({ action, event: this.event });
    }
    redirect() {
        const url = this.type === 'events' ? `/private/edit-event/${this.event.vc_uuid}` : `/private/edit-offer/${this.event.vc_uuid}`;
        this.router.navigate([url]);
    }
}
